module.exports = __webpack_public_path__ + "img/kuka.6d593fe7.jpg";